/**
 * Review if value is not null or an empty string.
 *
 * @param val Value to review.
 */
export const simpleValueValidation: (val) => boolean = val => val != null && `${val}`.trim() !== '';

export const isDash: (val: string) => boolean = val => val.trim() === '-';

export const multipleSimpleValueValidation: (...values: Array<string | number>) => boolean = (...values: string[]) =>
  values.reduce((acc, val) => acc && simpleValueValidation(val), true);
